// reducers/profileReducer.js
import * as types from '../types/merchantRoleAccessTypes';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const merchantRoleAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_MERCHANT_ROLE_ACCESS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_MERCHANT_ROLE_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case types.FETCH_MERCHANT_ROLE_ACCESS_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default merchantRoleAccessReducer;
